import { useThemeValue } from "@gravity-ui/uikit";
import React from "react";
import { Helmet } from "react-helmet";

export const HeadProvider = ({ children }: React.PropsWithChildren) => {
  const theme = useThemeValue();
  return (
    <>
      <Helmet>
        <meta
          name="theme-color"
          content={theme === "dark" ? "rgb(34, 29, 34)" : "white"}
        />
        <meta
          name="apple-mobile-web-app-status-bar-style"
          content={theme === "dark" ? "rgb(34, 29, 34)" : "white"}
        />
      </Helmet>
      {children}
    </>
  );
};
